// Loader.tsx
import React from 'react';
import './Loader.css'; // Make sure to create a CSS file for styles

const Loader: React.FC = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-content">
        <p>Please do not refresh or click any other button.</p>
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Loader;
